import React from 'react';
import {FormattedMessage} from 'react-intl';
import SocialShareLink from 'modules/common/SocialShareLink';

const ShareVideoTutorials = () => {
  const url = window.location.href;

  return (
    <div>
      <p className="mv3 black-80 f5">
        <FormattedMessage id="share_video_on_social_media" />
      </p>
      <div className="flex">
        <SocialShareLink url={url} />
      </div>
    </div>
  );
};

export default ShareVideoTutorials;
